import React from "react";
import SEO from "./seo";
import { content, BlogPost } from "../lib/content";

const DEFAULT_TITLE = "Pieńkowski – Kancelaria Adwokacka";
const DEFAULT_DESCRIPTION =
  "Kancelaria adwokacka w Warszawie. Prawa zwierząt, spory z bankami (franki/SKD/WIBOR) i sprawy cywilne. Pomoc po polsku, angielsku i hiszpańsku. Umów konsultację.";

type Meta = { title: string; description: string };

// Meta dla konkretnych URL-i (path bez domeny)
const META_BY_PATH: Record<string, Meta> = {
  "/": {
    title: "Pieńkowski – Kancelaria Adwokacka w Warszawie | Zwierzęta, Franki, SKD, WIBOR",
    description:
      "Kancelaria adwokacka w Warszawie. Prawa zwierząt, spory z bankami (franki/SKD/WIBOR) i sprawy cywilne. Pomoc po polsku, angielsku i hiszpańsku. Umów konsultację.",
  },

  "/o-nas": {
    title: "Adwokat Piotr Pieńkowski | Kancelaria w Warszawie | Pieńkowski Legal",
    description:
      "Jestem adwokatem z Warszawy. Pomagam w sprawach praw zwierząt, sporach z bankami (franki/SKD/WIBOR) oraz w sprawach cywilnych. Przejrzyste zasady współpracy i kontakt.",
  },
  "/about-me": {
    title: "Attorney Piotr Pieńkowski | Law Firm in Warsaw | Pieńkowski Legal",
    description:
      "I am an attorney (adwokat) based in Warsaw. I help with animal law matters, disputes with banks (CHF loans, SKD, WIBOR) and civil cases. Clear rules of cooperation and contact.",
  },

  "/sobre-mi": {
    title: "Abogado Piotr Pieńkowski | Despacho en Varsovia | Pieńkowski Legal",
    description:
      "Soy abogado en Varsovia. Ayudo en casos de derecho de los animales, disputas con bancos (francos suizos, SKD, WIBOR) y asuntos civiles. Reglas claras de colaboración y contacto.",
  },

  "/blog": {
    title: "Blog | Prawa zwierząt i spory z bankami | Pieńkowski Legal",
    description:
      "Artykuły i FAQ w sprawach z obszaru mojej praktyki: prawa zwierząt (Paragraf Zwierzoochronny), franki/SKD/WIBOR oraz sprawy cywilne.",
  },

  "/prawa-zwierzat/cywil": {
    title: "Prawa zwierząt – sprawy cywilne | Adwokat Warszawa | Pieńkowski",
    description:
      "Roszczenia związane ze szkodą na osobie wyrządzoną przez zwierzę, ze szkodą na zwierzęciu, rękojmia za “wadliwe” zwierzę, spory o zwierzę po rozstaniu, błąd weterynaryjny.",
  },

  "/zwierzeta/cywil/pogryzienie-czlowieka": {
    title: "Szkoda na osobie wyrządzona przez zwierzę | Adwokat Warszawa | Pieńkowski",
    description:
      "Pomagam dochodzić roszczeń, w tym odszkodowania lub zadośćuczynienia, związanych ze szkodą na osobie wyrządzoną przez zwierzę (najczęściej pogryzieniem przez psa).",
  },

  "/zwierzeta/cywil/pogryzienie-zwierzecia": {
    title: "Szkoda na zwierzęciu | Prawa zwierząt | Pieńkowski",
    description:
      "Pomagam dochodzić roszczeń związanych ze szkodą na zwierzęciu: odszkodowania, w tym kosztów leczenia, rehabilitacji, opieki oraz zadośćuczynienia.",
  },

  "/zwierzeta/cywil/rekojmia-zwierze": {
    title: "Rękojmia za “wadliwe” zwierzę | Zwrot, obniżka ceny | Pieńkowski",
    description:
      "Sprzedane zwierzę jest niezgodne z umową? Pomagam dochodzić roszczeń z rękojmi: obniżenie ceny, odstąpienie od umowy, w niektórych przypadkach wymiana zwierzęcia. Analiza dokumentów oraz wsparcie w sporze ze sprzedawcą, również przed sądem.",
  },

  "/zwierzeta/cywil/spor-o-psa-po-rozstaniu": {
    title: "Spór o zwierzę po rozstaniu | Własność zwierzęcia | Pieńkowski",
    description:
      "Pomagam rozwiązać spór o zwierzę po rozstaniu: ustalenie własności, wydanie zwierzęcia, rozliczenia kosztów. Jasna strategia, negocjacje i prowadzenie sprawy, w tym w sądzie.",
  },

  "/zwierzeta/cywil/blad-weterynaryjny": {
    title: "Błąd weterynaryjny – roszczenia | Odpowiedzialność kliniki | Pieńkowski",
    description:
      "Pomagam w sprawach dotyczących błędów weterynaryjnych: o odszkodowanie, w tym zwrot kosztów leczenia oraz o zadośćuczynienie. Analiza sprawy, strategia działania oraz pomoc przed sądem.",
  },

  "/spory-kredytobiorcow-z-bankami": {
    title: "Spory z bankami | Franki, SKD, WIBOR | Adwokat Warszawa | Pieńkowski",
    description:
      "Pomagam kredytobiorcom w sporach z bankami: kredyty frankowe, sankcja kredytu darmowego (SKD), WIBOR. Analiza umowy, strategia, negocjacje, prowadzenie sporów sądowych.",
  },

  "/spory-kredytobiorcow-z-bankami/franki": {
    title: "Kredyty frankowe (CHF) | Unieważnienie umowy, rozliczenia | Pieńkowski",
    description:
      "Oceniam umowę frankową, analizuję ryzyka i przedstawiam optymalne rozwiązania, w tym unieważnienie umowy, zabezpieczenie roszczeń, ugoda. Prowadzę sprawy kredytobiorców w Warszawie oraz na terenie całego kraju.",
  },

  "/spory-kredytobiorcow-z-bankami/skd": {
    title: "Sankcja kredytu darmowego (SKD) | Zwrot kosztów kredytu | Pieńkowski",
    description:
      "Sprawdź, czy przysługuje Ci sankcja kredytu darmowego. Pomagam przeanalizować dokumenty kredytowe, przygotować oświadczenie o skorzystaniu z SKD i dochodzić roszczeń wobec banku. Jasne kroki i prowadzenie sprawy.",
  },

  "/spory-kredytobiorcow-z-bankami/wibor": {
    title: "WIBOR – spór z bankiem | Analiza umowy i roszczenia | Pieńkowski",
    description:
      "Analizuję umowy kredytowe oparte o WIBOR. Pomagam w przygotowaniu strategii, negocjacjach oraz postępowaniu sądowym w sprawach dotyczących umów z WIBOR.",
  },
};

// --- BLOG META: tytuł/teaser dla /blog/<slug>.html ---
const getBlogMeta = (path: string): Meta | null => {
  if (!path.startsWith("/blog/")) return null;

  const slug = path.replace("/blog/", "").replace(/\.html$/, "");
  const locales = ["pl", "en", "es"] as const;

  let post: BlogPost | undefined;

  for (const loc of locales) {
    const posts = (content as any)[loc]?.blog?.posts as BlogPost[] | undefined;
    if (!posts) continue;

    // 1) standard: po slug
    post = posts.find((p: any) => p.slug === slug);

    // 2) fallback: po linku (najpewniejsze, bo odpowiada realnemu URL)
    if (!post) {
      post = posts.find((p: any) => {
        const link: string | undefined = p.link;
        if (!link) return false;
        // link bywa "/blog/xxx.html" albo pełny URL — bierzemy tylko końcówkę
        return link.includes(`/blog/${slug}.html`);
      });
    }

    if (post) break;
  }

  if (!post) return null;

  return {
    title: `${(post as any).title} | Pieńkowski – Kancelaria Adwokacka`,
    description: (post as any).teaser ?? DEFAULT_DESCRIPTION,
  };
};
export default function GlobalSEO() {
  const canonicalPath = window.location.pathname || "/";

  const blogMeta = getBlogMeta(canonicalPath);

  // Priorytet: blogpost -> mapa -> default
  const meta =
    blogMeta ??
    META_BY_PATH[canonicalPath] ??
    {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION,
    };

  return (
    <SEO
      title={meta.title}
      description={meta.description}
      canonicalPath={canonicalPath}
      ogImagePath="/Photo.png"
    />
  );
}